<template>
    <v-simple-table>
        <template v-slot:default>
            <thead style="background-color: #eee">
                <tr>
                    <th>IMMAGINE</th>
                    <th>CODICE</th>
                    <th>
                        <v-icon
                            small
                            v-if="
                                order.ar_descr != undefined &&
                                order.ar_descr == 'desc'
                            "
                            >mdi-menu-down</v-icon
                        >
                        <v-icon
                            small
                            v-else-if="
                                order.ar_descr != undefined &&
                                order.ar_descr == 'asc'
                            "
                            >mdi-menu-up</v-icon
                        >
                        <v-icon small v-else>unfold_less</v-icon>
                        <br />
                        <a
                            href="#"
                            @click="$emit('changeOrderDirection', 'ar_descr')"
                            >DESCRIZIONE</a
                        >
                    </th>
                    <th>PPREZZO</th>
                    <th v-for="shop in shops" :key="shop.id">
                        <div>
                            <v-icon
                                small
                                v-if="
                                    order['shops.' + shop.id + '.totale_prezzo'] !=
                                        undefined && order['shops.' + shop.id + '.totale_prezzo'] == 'desc'
                                "
                                >mdi-menu-down</v-icon
                            >
                            <v-icon
                                small
                                v-else-if="
                                    order['shops.' + shop.id + '.totale_prezzo'] !=
                                        undefined && order['shops.' + shop.id + '.totale_prezzo'] == 'asc'
                                "
                                >mdi-menu-up</v-icon
                            >
                            <v-icon small v-else>unfold_less</v-icon>
                            <br />
                            <a
                                href="#"
                                @click="
                                    $emit(
                                        'changeOrderDirection',
                                        'shops.' + shop.id + '.totale_prezzo'
                                    )
                                "
                                >{{ shop.description }}</a
                            >
                        </div>
                    </th>
                    <th>TOTALE</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="prod in data" :key="prod.cod_articolo">
                    <td style="padding: 2px 0">
                        <router-link
                            target="_blank"
                            :to="{
                                name: 'product',
                                query: {
                                    id: prod.cod_articolo,
                                },
                            }"
                        >
                            <v-img
                                :src="imagePath(prod.cod_articolo)"
                                width="80"
                                height="80"
                            ></v-img>
                        </router-link>
                    </td>
                    <td>{{ prod.cod_articolo }}</td>
                    <td>{{ prod.ar_descr }}</td>
                    <td>{{ prod.lc_prezzo2 | formatEuro }}</td>
                    <td v-for="shop in shops" :key="shop.id">
                        {{ getProdVenditeFromShop(shop.id, prod) }}
                    </td>
                    <td>
                        <span v-if="fieldType == 'prezzo'">{{
                            prod.prezzo_tot | formatEuro
                        }}</span>
                        <span v-else-if="fieldType == 'qty'">{{
                            prod.qty_tot
                        }}</span>
                    </td>
                </tr>
            </tbody>
        </template>
    </v-simple-table>
</template>
<style scoped lang="scss">
.v-data-table::v-deep > .v-data-table__wrapper > table {
    border-spacing: 1px;

    th {
        text-align: center !important;
    }
    th,
    td {
        border: 1px solid black;
        font-weight: bold;
    }
}
</style>
<script>
export default {
    name: "product-sell-table",
    props: {
        data: {
            type: Array,
            required: true,
        },
        shops: {
            type: Array,
            required: true,
        },
        fieldType: {
            type: String,
            required: true,
        },
        order: {
            type: Object,
            required: true,
        },
    },

    mounted() {
        console.log("Product Sell Table Mounted.");
    },
    methods: {
        imagePath(prodId) {
            if (!this.error) {
                let normId = prodId.replace("/", "_") + ".jpg";
                return "/images/catalog/lower/" + normId;
            } else {
                return "no_image.jpg";
            }
        },
        getProdVenditeFromShop(shopId, prod) {
            if (this.fieldType == "prezzo") {
                if (!_.isUndefined(prod.shops[shopId])) {
                    return this.formatEuro(prod.shops[shopId].totale_prezzo);
                } else return this.formatEuro(0);
            } else if (this.fieldType == "qty") {
                if (!_.isUndefined(prod.shops[shopId])) {
                    return prod.shops[shopId].totale_qty;
                } else return 0;
            }
        },
        formatEuro(number) {
            if (_.isNaN(number)) return 0;
            return new Intl.NumberFormat("it-IT", {
                style: "currency",
                currency: "EUR",
            }).format(number);
        },
    },
    filters: {
        formatEuro(number) {
            if (_.isNaN(number)) return 0;
            return new Intl.NumberFormat("it-IT", {
                style: "currency",
                currency: "EUR",
            }).format(number);
        },
    },
};
</script>
